import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from './cx';
/**
 * `one-table-wrap` > `one-table`. Zahlenzellen bekommen `className="num"`, IDs
 * `className="mono"`, Auswahl `aria-selected`, Fehlerzeilen `data-tone="danger"`.
 */
export function Table({ foot, maxHeight, className, children, ...rest }) {
    return (_jsxs("div", { className: "one-table-wrap", style: maxHeight ? { maxHeight } : undefined, children: [_jsx("table", { className: cx('one-table', className), ...rest, children: children }), foot && _jsx("div", { className: "one-table-foot", children: foot })] }));
}
/** Zelle, die umbrechen darf (Beschreibungen). Standard in ONE-Tabellen ist nowrap. */
export function WrapCell({ className, ...rest }) {
    return _jsx("td", { className: cx('one-wrap', className), ...rest });
}
